import type { FC } from 'react';

export const EmptyComponent: FC = () => null;
